<template>
  <div>
    <b-card>
      <b-form>
        <b-row>
          <b-col md="2">
            <b-form-group label="Pesquisar Por:" label-for="searchBy">
              <b-form-select id="searchBy" v-model="search.searchBy" :options="optionsSearchBy" />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Descrição" label-for="searchValue">
              <Cleave
                v-if="search.searchBy === 1"
                id="cnpj"
                type="text"
                placeholder="##.###.###/####-##"
                v-model="search.searchValue"
                :raw="false"
                :options="cleave.cnpj"
                class="form-control"
              />
              <b-form-input v-else id="searchValue" placeholder="Nome" v-model="search.searchValue" />
            </b-form-group>
          </b-col>

          <b-col class="d-flex">
            <b-col md="auto">
              <b-button :disabled="isLoading" variant="primary" style="margin-top: 20px; width: 160px" @click="handleSearch()">
                <b-spinner small v-if="isLoading" />
                {{ !isLoading ? 'Pesquisar' : '' }}
              </b-button>
            </b-col>
            <b-col md="auto" v-if="acesso.ConfiguracoesSistemaCessionariaCadastrar">
              <b-button variant="primary" style="margin-top: 20px; width: 160px" @click="handleCreate()">
                Novo Cadastro
              </b-button>
            </b-col>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <b-card v-if="items.length > 0">
      <b-table
        striped
        responsive
        id="table_cessionary"
        class="position-relative"
        :items="items"
        :fields="fields"
        v-show="items.length > 0"
        :per-page="table.perPage"
        :current-page="table.currentPage"
        :sort-by.sync="table.sortBy"
        :sort-desc.sync="table.sortDesc"
        :sort-direction="table.sortDirection"
        :busy="isLoading"
      >
        <template v-slot:table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-1"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>

        <template #cell(opcoes)="row">
          <b-dropdown variant="link" no-caret toggle-class="p-0" left :popper-opts="{ positionFixed: true }">
            <template #button-content>
              <b-button variant="primary" class="btn-icon" title="Este botão contém as opções disponíveis para este registro">
                <feather-icon icon="SettingsIcon" />
              </b-button>
            </template>
            <b-dropdown-item @click="handleParams(row.item)">
              <feather-icon icon="SettingsIcon" size="16" />
              <span class="align-middle ml-50">Parâmetros</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="acesso.ConfiguracoesSistemaCessionariaEditar" @click="handleCreate(row.item)">
              <feather-icon icon="EditIcon" size="16" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="acesso.ConfiguracoesSistemaCessionariaExcluir" @click="handleDelete(row.item.id)">
              <feather-icon icon="XIcon" size="16" />
              <span class="align-middle ml-50">Excluir</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <b-card-body v-if="items.length > 0" class="d-flex justify-content-between flex-wrap pt-0">
        <b-form-group
          style="align-items: center"
          label="Por Página"
          label-cols="6"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select id="perPageSelect" v-model="table.perPage" size="sm" inline :options="table.pageOptions" />
        </b-form-group>
        <b-pagination
          v-model="table.currentPage"
          :total-rows="items.length"
          :per-page="table.perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-card-body>
    </b-card>
    <b-modal ref="cessionaria-create-modal" centered size="lg" title="Cadastro da Cessionária" no-close-on-backdrop hide-footer>
      <CessionariaCreateModal :handleClose="handleClose" :item="item" :mode="mode" />
    </b-modal>
    <b-modal
      ref="cessionaria-params-modal"
      centered
      size="xl"
      title="Parâmetros da Cessionária"
      no-close-on-backdrop
      hide-footer
    >
      <CessionariaParamsModal :item="item" />
    </b-modal>
  </div>
</template>

<script>
  import CessionariaCreateModal from './CessionariaCreateModal.vue'
  import CessionariaParamsModal from './CessionariaParamsModal.vue'

  import useJwt from '@/auth/jwt/useJwt'
  import Cleave from 'vue-cleave-component'

  export default {
    components: {
      CessionariaCreateModal,
      CessionariaParamsModal,
      Cleave,
    },

    data() {
      return {
        userData: this.$jwtDecode(localStorage.getItem('userData')).userData,
        isLoading: false,

        optionsSearchBy: [
          { value: 1, text: 'CNPJ' },
          { value: 2, text: 'Nome' },
        ],

        search: {
          searchBy: 1,
          searchValue: '',
        },
        table: {
          perPage: 10,
          currentPage: 1,
          pageOptions: [10, 50, 100],
          sortBy: '',
          sortDesc: false,
          sortDirection: 'asc',
        },

        cleave: {
          cnpj: {
            delimiters: ['.', '.', '/', '-'],
            numericOnly: true,
            blocks: [2, 3, 3, 4, 2],
          },
        },

        items: [],
        item: {},
        mode: 'create',
        fields: [
          { key: 'opcoes', label: 'Opções', sortable: false },
          { key: 'cnpj', label: 'CNPJ' },
          { key: 'name', label: 'Nome da Cessionária', sortable: true },
          { key: 'responsible', label: 'Nome do Responsável', sortable: true },
          { key: 'email', label: 'E-mail Responsável' },
          { key: 'phone', label: 'Telefone Responsável' },
        ],

        acesso: {
          ConfiguracoesSistemaCessionariaCadastrar: true,
          ConfiguracoesSistemaCessionariaEditar: true,
          ConfiguracoesSistemaCessionariaExcluir: true,
        },
      }
    },
    computed: {},
    mounted() {
      if (this.userData.role == 'master') {
        this.acesso.ConfiguracoesSistemaCessionariaCadastrar = true
        this.acesso.ConfiguracoesSistemaCessionariaEditar = true
        this.acesso.ConfiguracoesSistemaCessionariaExcluir = true
      } else {
        this.acesso.ConfiguracoesSistemaCessionariaCadastrar =
          this.userData.GrupoAcesso.ConfiguracoesSistemaCessionariaCadastrar
        this.acesso.ConfiguracoesSistemaCessionariaEditar = this.userData.GrupoAcesso.ConfiguracoesSistemaCessionariaEditar
        this.acesso.ConfiguracoesSistemaCessionariaExcluir = this.userData.GrupoAcesso.ConfiguracoesSistemaCessionariaExcluir
      }
    },
    methods: {
      async handleSearch() {
        this.isLoading = true

        await useJwt
          .post('cessionaria/batch', this.search)
          .then((response) => {
            this.items = response.data
          })
          .catch((error) => {
            this.$message.error('Erro ao buscar cessionárias!')
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      handleCreate(item) {
        if (item) {
          this.item = item
          this.mode = 'edit'
        } else {
          this.mode = 'create'
          this.item = {}
        }
        this.$refs['cessionaria-create-modal'].show()
      },
      handleClose() {
        this.$refs['cessionaria-create-modal'].hide()
        this.handleSearch()
      },

      handleParams(item) {
        this.item = item
        this.$refs['cessionaria-params-modal'].show()
      },

      handleDelete(id) {
        this.$swal({
          title: 'Atenção!',
          text: 'Deseja realmente excluir esse registro?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim!',
          cancelButtonText: 'Não!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            useJwt
              .delete(`cessionaria`, id)
              .then(() => {
                this.$message.success('Cessionária excluida com sucesso!')
                this.handleSearch()
              })
              .catch((error) => {
                this.$message.error('Erro ao excluir cessionária!')
              })
          }
        })
      },
    },
  }
</script>

<style></style>
